export const sortDashboardsByPosition = (a: { position: number }, b: { position: number }) =>
  a ? a.position - b.position : 1;
